import { type DOMOutputSpec, type NodeSpec } from "prosemirror-model";

export const table_header: NodeSpec = {
	content: "inline*",
	tableRole: "header_cell",
	isolating: true,
	parseDOM: [{ tag: "th" }],
	toDOM(): DOMOutputSpec {
		return ["th", 0];
	},
};
